var exports = {
  "i": "xaee3c4fa--a93d3c--wrapper",
};

module.exports = exports;
